/* import __COLOCATED_TEMPLATE__ from './teammate-app-boot-error.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */
import templateOnlyComponent from '@ember/component/template-only';

const TeammateAppBootError = templateOnlyComponent();
export default TeammateAppBootError;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    TeammateAppBootError: typeof TeammateAppBootError;
    'teammate-app-boot-error': typeof TeammateAppBootError;
  }
}
